function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1CA2E1",
  fillRule: "evenodd",
  d: "M5.158 5.66l-.001.754-4.42.001v12.83h12.526V6.415H8.842V5.66H14V20H0V5.66h5.158zM7 0v.001l3.074 3.152-.546.565-2.16-2.216V12.83h-.736L6.63 1.503 4.473 3.718l-.546-.565L7 .001V0z"
});

var SvgIosShare = function SvgIosShare(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 20"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAyMCI+CiAgICA8cGF0aCBmaWxsPSIjMUNBMkUxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE1OCA1LjY2bC0uMDAxLjc1NC00LjQyLjAwMXYxMi44M2gxMi41MjZWNi40MTVIOC44NDJWNS42NkgxNFYyMEgwVjUuNjZoNS4xNTh6TTcgMHYuMDAxbDMuMDc0IDMuMTUyLS41NDYuNTY1LTIuMTYtMi4yMTZWMTIuODNoLS43MzZMNi42MyAxLjUwMyA0LjQ3MyAzLjcxOGwtLjU0Ni0uNTY1TDcgLjAwMVYweiIgLz4KPC9zdmc+Cg==";
export { SvgIosShare as ReactComponent };